import { Injectable, ErrorHandler } from '@angular/core';
import * as Sentry from "@sentry/angular";
import { AuthenticationService } from '../service/authentication.service';

// Noise the app emits as messages during normal operation; anything else is kept.
const DROPPED_MESSAGES = ['this.colors.getColor', 'Compiling', 'Warning'];

@Injectable()
export class SentryErrorHandler implements ErrorHandler {

  constructor(private authenticationService: AuthenticationService) {
    // DSN, environment and release are rendered into assets/env.js by the
    // container entrypoint, so one image serves every environment.
    const dsn = window.env?.sentryDsn;
    if (!dsn) {
      return;
    }

    Sentry.init({
      dsn,
      environment: window.env?.sentryEnvironment,
      release: window.env?.sentryRelease,
      maxValueLength: 100000,
      beforeSend(event) {
        const message = event.message?.toString();
        if (message && DROPPED_MESSAGES.some(noise => message.includes(noise))) {
          return null;
        }
        return event;
      },
    });
	}

  handleError(error) {
    const chunkFailedMessage = /Loading chunk [\d]+ failed/;

    if (chunkFailedMessage.test(error.message)) {
      window.location.reload();
    }

    Sentry.setUser({
      'user': this.authenticationService.currentUserValue});
    Sentry.captureException(error.originalError || error);
	}
}
